module.exports = __webpack_public_path__ + "static/media/cablecircle1.f1c20648.png";